function show() {
  document.getElementById("s_one").style.display ="block";
}
function show1() {
  document.getElementById("s_two").style.display = "block";
}
function show2() {
  document.getElementById("s_three").style.display = "block";
}
function show3() {
  document.getElementById("s_four").style.display = "block";
}

$(document).ready(function(){
  $('.jump_click').click(function(){
    $('html, body').animate({
      scrollTop: $( $(this).attr('href') ).offset().top
    }, 500);
    return false;
  });
});